import React, { useState } from 'react';
import { useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Helper function for handling navigation
  const handleNavClick = (e, path, scrollIndex) => {
    e.preventDefault();

    if (location.pathname === path) {
      // Same page - perform scrolling
      const targetElement = document.querySelector(`[data-scroll-index="${scrollIndex}"]`);
      if (targetElement) {
        const offsetTop = targetElement.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    } else {
      // Different page - navigate to the specified route
      window.location.href = path;
    }
    
    // Close menu after navigation on mobile
    setIsMenuOpen(false);
  };

  // Toggle menu function
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scrolling when menu is open
    document.body.style.overflow = !isMenuOpen ? 'hidden' : 'unset';
  };

  return (
    <>
      <nav className="navbar navbar-expand-lg nav-crev">
        <div className="container">
          <a className="logo icon-img-100" href="/">
            <img src="/dark/assets/imgs/logo-light.png" alt="logo" />
          </a>

          <div
            className={`collapse navbar-collapse justify-content-center ${isMenuOpen ? 'show' : ''}`}
            id="navbarSupportedContent"
          >
            <ul className="navbar-nav">
              <li className="nav-item">
                <a className="nav-link" href="/" onClick={(e) => handleNavClick(e, "/", 0)}>
                  <span className="rolling-text">Home</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/dark/page-services" onClick={(e) => handleNavClick(e, "/dark/page-services", 1)}>
                  <span className="rolling-text">Services</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/dark/page-about3" onClick={(e) => handleNavClick(e, "/dark/page-about3", 2)}>
                  <span className="rolling-text">About</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/dark/page-team" onClick={(e) => handleNavClick(e, "/dark/page-team", 3)}>
                  <span className="rolling-text">Team</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/dark/page-FAQS" onClick={(e) => handleNavClick(e, "/dark/page-FAQS", 4)}>
                  <span className="rolling-text">FAQS</span>
                </a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/dark/page-contact" onClick={(e) => handleNavClick(e, "/dark/page-contact", 5)}>
                  <span className="rolling-text">Contact</span>
                </a>
              </li>
            </ul>
            {/* <a href="https://wa.me/917090048025?text=Hi!%20I%27d%20like%20to%20know%20more%20about%20your%20services"><i className="fab fa-whatsapp"></i></a> */}
          </div>

          {/* Single menu trigger button */}
          <div className="menu-trigger" onClick={toggleMenu}>
            <span className="icon ti-align-right"></span>
          </div>
        </div>
      </nav>

      <div className={`hamenu one-scroll ${isMenuOpen ? 'open' : ''}`}>
        <div className="logo icon-img-100">
          <img src="/dark/assets/imgs/logo-light.png" alt="" />
        </div>
        <div className="close-menu cursor-pointer ti-close" onClick={toggleMenu}></div>
        <div className="container">
          <div className="row">
            <div className="col-lg-2">
              <div className="menu-text">
                <div className="text">
                  <h2>Menu</h2>
                </div>
              </div>
            </div>
            <div className="col-lg-7">
              <div className="menu-links">
                <ul className="main-menu rest">
                  <li data-scroll-nav="0" onClick={(e) => handleNavClick(e, "/", 0)}>
                    <div className="o-hidden">
                      <div className="link cursor-pointer dmenu">
                        <span className="fill-text" data-text="Home">Home</span>
                      </div>
                    </div>
                  </li>
                  <li data-scroll-nav="1" onClick={(e) => handleNavClick(e, "/dark/page-services", 1)}>
                    <div className="o-hidden">
                      <div className="link cursor-pointer dmenu">
                        <span className="fill-text" data-text="Services">Services</span>
                      </div>
                    </div>
                  </li>
                  <li data-scroll-nav="2" onClick={(e) => handleNavClick(e, "/dark/page-about3", 2)}>
                    <div className="o-hidden">
                      <div className="link cursor-pointer dmenu">
                        <span className="fill-text" data-text="About">About</span>
                      </div>
                    </div>
                  </li>
                  <li data-scroll-nav="3" onClick={(e) => handleNavClick(e, "/dark/page-team", 3)}>
                    <div className="o-hidden">
                      <div className="link cursor-pointer dmenu">
                        <span className="fill-text" data-text="Team">Team</span>
                      </div>
                    </div>
                  </li>
                  <li data-scroll-nav="4" onClick={(e) => handleNavClick(e, "/dark/page-FAQS", 4)}>
                    <div className="o-hidden">
                      <div className="link cursor-pointer dmenu">
                        <span className="fill-text" data-text="FAQS">FAQS</span>
                      </div>
                    </div>
                  </li>
                  <li data-scroll-nav="5" onClick={(e) => handleNavClick(e, "/dark/page-contact", 5)}>
                    <div className="o-hidden">
                      <div className="link cursor-pointer dmenu">
                        <span className="fill-text" data-text="Contact">Contact</span>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="cont-info">
                <div className="item mb-50">
                  <h6 className="sub-title mb-15 opacity-7">Address</h6>
                  <h5>No. 40, Govinda Gopala Krupa, Dsouza Layout, Banashankari 3rd Stage,<br /> Hosakerehalli, Bengaluru, Karnataka 560085</h5>
                </div>
                <div className="item mb-50">
                  <h6 className="sub-title mb-15 opacity-7">Social Media</h6>
                  <ul className="rest social-text">
                    <li className="mb-10">
                      <a href="#0" className="hover-this"><span className="hover-anim">Facebook</span></a>
                    </li>
                    <a href="https://www.youtube.com/@stepinhomeservices"><i className="fab fa-youtube"></i></a>
                    <li>
                      <a href="https://www.instagram.com/stepinhomeservices?utm_source=qr&igsh=MWNwdHc3eDI1NWQwNg==" className="hover-this"><span className="hover-anim">Instagram</span></a>
                    </li>
                  </ul>
                </div>
                <div className="item mb-40">
                  <h6 className="sub-title mb-15 opacity-7">Contact Us</h6>
                  <h5><a href="#0">info@stepinhomeservices.com</a></h5>
                  <h5 className="underline mt-10"><a href="#0">7090048025</a></h5>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Navbar;

